<template>
  <component
    :is="multiline ? 'v-textarea' : 'v-text-field'"
    :value="value"
    :label="label"
    :rows="multiline ? 3 : undefined"
    :height="multiline ? undefined : 20"
    :class="{ dense: !multiline }"
    autocomplete="off"
    outlined
    dense
    hide-details
    :clearable="!copyable"
    :append-icon="copyable && value ? (copied ? 'mdi-check' : 'mdi-content-copy') : undefined"
    @click:append="copy"
    @input="$emit('input', $event)"
  />
</template>

<script>
// Thin wrapper over a plain outlined dense field: adds a copy button.
// Stays RTL like the rest of the form; no `dir` override (it flips the
// outline notch away from the label).
// Field look comes from the global `input-minimal` class on the parent. Copy state lives here so the parent's posted $data stays clean.
import { VTextField, VTextarea } from 'vuetify/lib'

export default {
  name: 'TaxSoftField',
  components: { VTextField, VTextarea },
  props: {
    value: { type: String, default: null },
    label: { type: String, default: '' },
    copyable: { type: Boolean, default: false },
    multiline: { type: Boolean, default: false },
  },
  data: () => ({ copied: false }),
  methods: {
    copy () {
      if (!this.value || !navigator.clipboard) return
      navigator.clipboard.writeText(this.value).then(() => {
        this.copied = true
        setTimeout(() => { this.copied = false }, 1500)
      }).catch(() => {})
    },
  },
}
</script>
